// extracted by mini-css-extract-plugin
export default {"statsContainer":"MarketplaceStats_statsContainer__dJlvY","statCard":"MarketplaceStats_statCard__uqAMR","statItem":"MarketplaceStats_statItem__Ji+Fk"};